module.exports = __webpack_public_path__ + "img/heart-hexagon.c5dfc3db.svg";